module.exports = __webpack_public_path__ + "assets/64.jpg?7e753d7cd80bf265209c7b7e18e36652";